"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayorRecordDtoToJSON = exports.PayorRecordDtoFromJSONTyped = exports.PayorRecordDtoFromJSON = exports.instanceOfPayorRecordDto = exports.PayorRecordDtoBillingProcessingGroupEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.PayorRecordDtoBillingProcessingGroupEnum = {
    Avalon: 'AVALON',
    Centene: 'CENTENE',
    Cigna: 'CIGNA',
    GenomeMedical: 'GENOME_MEDICAL',
    MedicareAdvantage: 'MEDICARE_ADVANTAGE',
    MedicareTraditional: 'MEDICARE_TRADITIONAL'
};
/**
 * Check if a given object implements the PayorRecordDto interface.
 */
function instanceOfPayorRecordDto(value) {
    var isInstance = true;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "countries" in value;
    isInstance = isInstance && "hbGovernmentPayor" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "isMedicaid" in value;
    isInstance = isInstance && "isMedicare" in value;
    isInstance = isInstance && "isPitEnabled" in value;
    isInstance = isInstance && "isExomeCovered" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "isInNetwork" in value;
    isInstance = isInstance && "isInternationalRestricted" in value;
    return isInstance;
}
exports.instanceOfPayorRecordDto = instanceOfPayorRecordDto;
function PayorRecordDtoFromJSON(json) {
    return PayorRecordDtoFromJSONTyped(json, false);
}
exports.PayorRecordDtoFromJSON = PayorRecordDtoFromJSON;
function PayorRecordDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'active': json['active'],
        'code': json['code'],
        'countries': json['countries'],
        'hbGovernmentPayor': json['hbGovernmentPayor'],
        'id': json['id'],
        'isMedicaid': json['isMedicaid'],
        'isMedicare': json['isMedicare'],
        'isPitEnabled': json['isPitEnabled'],
        'isExomeCovered': json['isExomeCovered'],
        'name': json['name'],
        'testsNotCovered': !(0, runtime_1.exists)(json, 'testsNotCovered') ? undefined : json['testsNotCovered'],
        'isInNetwork': json['isInNetwork'],
        'isInternationalRestricted': json['isInternationalRestricted'],
        'oopEstimate': !(0, runtime_1.exists)(json, 'oopEstimate') ? undefined : json['oopEstimate'],
        'primaryIndications': !(0, runtime_1.exists)(json, 'primaryIndications') ? undefined : json['primaryIndications'],
        'prCodesNotCovered': !(0, runtime_1.exists)(json, 'prCodesNotCovered') ? undefined : json['prCodesNotCovered'],
        'paSubmissionLimitDays': !(0, runtime_1.exists)(json, 'paSubmissionLimitDays') ? undefined : json['paSubmissionLimitDays'],
        'paSubmissionMethods': !(0, runtime_1.exists)(json, 'paSubmissionMethods') ? undefined : json['paSubmissionMethods'],
        'paUsers': !(0, runtime_1.exists)(json, 'paUsers') ? undefined : json['paUsers'],
        'retroActivePALimitDays': !(0, runtime_1.exists)(json, 'retroActivePALimitDays') ? undefined : json['retroActivePALimitDays'],
        'priority': !(0, runtime_1.exists)(json, 'priority') ? undefined : json['priority'],
        'billingProcessingGroup': !(0, runtime_1.exists)(json, 'billingProcessingGroup') ? undefined : json['billingProcessingGroup'],
    };
}
exports.PayorRecordDtoFromJSONTyped = PayorRecordDtoFromJSONTyped;
function PayorRecordDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'active': value.active,
        'code': value.code,
        'countries': value.countries,
        'hbGovernmentPayor': value.hbGovernmentPayor,
        'id': value.id,
        'isMedicaid': value.isMedicaid,
        'isMedicare': value.isMedicare,
        'isPitEnabled': value.isPitEnabled,
        'isExomeCovered': value.isExomeCovered,
        'name': value.name,
        'testsNotCovered': value.testsNotCovered,
        'isInNetwork': value.isInNetwork,
        'isInternationalRestricted': value.isInternationalRestricted,
        'oopEstimate': value.oopEstimate,
        'primaryIndications': value.primaryIndications,
        'prCodesNotCovered': value.prCodesNotCovered,
        'paSubmissionLimitDays': value.paSubmissionLimitDays,
        'paSubmissionMethods': value.paSubmissionMethods,
        'paUsers': value.paUsers,
        'retroActivePALimitDays': value.retroActivePALimitDays,
        'priority': value.priority,
        'billingProcessingGroup': value.billingProcessingGroup,
    };
}
exports.PayorRecordDtoToJSON = PayorRecordDtoToJSON;
